import React from 'react'
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
    containerVariants,
    itemVariants,
    photoVariants,
} from "../../variants/variants";



const Section8 = () => {
    const { t } = useTranslation();
    
    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            exit="exit"
            variants={containerVariants}
            className="min-h-[60vh]  w-full  relative flex items-end">

            <motion.img
                initial="initial"
                whileInView="whileInView"
                exit="exit"
                variants={photoVariants}
                src="/images/sustainability/sustainability.jpg"
                className="object-cover h-full w-full object-center absolute top-0 left-0"
            />

            <motion.div initial="initial"
                whileInView="whileInView"
                exit="exit"
                variants={photoVariants} className=" w-full   absolute top-0 left-0"></motion.div>

            <div className="grid grid-cols-10   w-full relative z-50 py-28 h-full   ">
                <div className=" col-start-2  col-span-8  w-full  grid grid-cols-1 md:grid-cols-2 text-white text-3xl md:text-5xl space-y-10 ">
                            <div className='  text-center '>{t("sustainability.compliance.social")}</div>
                            <div className='  text-center'>{t("sustainability.compliance.sustainability")}</div>
                </div>
            </div>

            
        </motion.div>
    )
}

export default Section8